/**
 * Should contain all Material Icons used on public site
 */
export enum MaterialIconId {
  arrowDownward = 'arrow_downward',
  arrowForward = 'arrow_forward',
  arrowUpward = 'arrow_upward',
  check = 'check',
  chevronLeft = 'chevron_left',
  chevronRight = 'chevron_right',
  close = 'close',
  checkCircle = 'check_circle',
  info = 'info',
  keyboardControlKey = 'keyboard_control_key',
  link = 'link',
  mail = 'mail',
  menu = 'menu',
  menuOpen = 'menu_open',
  newWindow = 'new_window',
  phone = 'phone',
  search = 'search',
  security = 'security',
  warning = 'warning',
  pictureAsPdf = 'picture_as_pdf',
  eventNote = 'event_note',
  keyboardArrowDown = 'keyboard_arrow_down',
  checkPhone = 'security_update_good',
  supportAgent = 'support_agent',
  receipt = 'receipt',
  collapseAll = 'collapse_all',
  expandAll = 'expand_all',
  support = 'support',
  groups = 'groups',
}
